/**
 * @file ppde页面
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useState} from 'react';
import {Tabs} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from './components/banner/Banner';
import Members from './components/members/Members';

import usePpdeHooks from './ppdeMLHooks';
import PpdeHeader from './components/ppde-header/PpdeHeader';

const PpdeML: React.FC = () => {
    const {
        members
    } = usePpdeHooks();

    const [sortKey, setSortKey] = useState<string>('entryTime');

    return (
        <div className="page paddle-ppde-page">
            <Header />
            <PpdeHeader />
            <Banner
                className="paddle-ppde-banner"
                title="开发者技术专家"
                subtitle="Paddle Paddle Developers Experts"
            />
            <div className="paddle-ppde-page-background">
                <div className="paddle-ppde-page-container">
                    <Tabs
                        className="paddle-ppde-sort-by-tabs"
                        activeKey={sortKey}
                        onChange={setSortKey}
                    >
                        <Tabs.TabPane
                            key="entryTime"
                            tab="最新入驻"
                        />
                        <Tabs.TabPane
                            key="name"
                            tab="A-Z"
                        />
                    </Tabs>
                    <Members {...members} sortBy={sortKey} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PpdeML;
